import { render, staticRenderFns } from "./ZekiInMovie.vue?vue&type=template&id=43b09746&lang=pug&"
import script from "./ZekiInMovie.vue?vue&type=script&lang=js&"
export * from "./ZekiInMovie.vue?vue&type=script&lang=js&"
import style0 from "./ZekiInMovie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports